import type { components } from '@core/types/clients/game-session'
import type { BingoLatestWinner, GameWinnerResponse } from '@game/types'

type WinData = components['schemas']['WinData']

// game-session paths are /game_tiles/{provider}/{vendor}/{slug}/{folder}/{file}.
const SITE_FOLDER_SEGMENT = 5

// game-session picks the asset folder by brand, but an app can be set to use another brand's
// folder (assetsSiteFolder, e.g. spinking-dk uses spilnu's art).
function withSiteFolder(path: string | null, siteFolder?: string): string {
    if (!path || !siteFolder) return path ?? ''

    const segments = path.split('/')
    if (segments.length !== SITE_FOLDER_SEGMENT + 2) return path

    segments[SITE_FOLDER_SEGMENT] = siteFolder

    return segments.join('/')
}

/**
 * Turns a game-session win into what the winner tiles render. The game fields are null when
 * game-configuration doesn't know the game: the tile then shows the slug and the brand icon.
 */
export function toGameWinner(win: WinData, siteFolder?: string): GameWinnerResponse & BingoLatestWinner {
    return {
        id: win.id,
        gameName: win.gameName ?? win.gameSlug,
        slug: win.gameSlug,
        wonBy: win.userDisplayName,
        // The bingo tiles read the older field names.
        username: win.userDisplayName,
        wonAt: win.wonAt,
        created: win.wonAt,
        amount: win.amount,
        gameIconPath: withSiteFolder(win.gameIconPath, siteFolder),
        gameLogoPath: withSiteFolder(win.gameLogoPath, siteFolder),
    }
}
